// ----------------------------------------------------------------------

export default function Grid() {
  return {
    MuiGrid: {
      defaultProps: {
        spacing: 2,
      },
      styleOverrides: {},
    },
    MuiStack: {
      defaultProps: {
        spacing: 2,
      },
    },
  };
}
